import { render, staticRenderFns } from "./common-problem-chinese2.vue?vue&type=template&id=0318379d&scoped=true"
import script from "./common-problem-chinese2.vue?vue&type=script&lang=js"
export * from "./common-problem-chinese2.vue?vue&type=script&lang=js"
import style0 from "./common-problem-chinese2.vue?vue&type=style&index=0&id=0318379d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0318379d",
  null
  
)

export default component.exports